/* Storefront interactions. No catalog data is stored in this asset. */
(() => {
  'use strict';
  const galleryCleanups = new WeakMap();
  function initProducts(scope = document) {
    scope.querySelectorAll('[data-variant-id]').forEach(input => { input.name = 'id'; });
    scope.querySelectorAll('.product__gallery').forEach(gallery => {
      if (gallery.dataset.carouselReady) return;
      gallery.dataset.carouselReady = 'true';
      gallery.classList.add('media');
      const section=gallery.closest('[data-product-section]'),nav=section?.querySelector('[data-product-thumbs]');
      const media=[...gallery.querySelectorAll('.product__media')];
      if (!media.length) return;
      const mobile = matchMedia('(max-width:1023px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      const english = document.documentElement.lang.startsWith('en');
      const wrapper = document.createElement('div');
      wrapper.className = 'product-gallery';
      gallery.before(wrapper);
      wrapper.append(gallery);
      gallery.id = `Gallery-${section.dataset.productSection}`;
      gallery.setAttribute('role', 'group');
      gallery.setAttribute('aria-label', english ? 'Product images' : 'Visuels du produit');
      gallery.tabIndex = 0;
      const controls = document.createElement('div');
      controls.className = 'product-gallery__controls';
      const arrow = (direction, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `product-gallery__arrow product-gallery__arrow--${direction}`;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-controls', gallery.id);
        button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 4 8 8-8 8"/></svg>';
        controls.append(button);
        return button;
      };
      const previous = arrow('previous', english ? 'Previous image' : 'Visuel précédent');
      const next = arrow('next', english ? 'Next image' : 'Visuel suivant');
      const dots = document.createElement('div');
      dots.className = 'product-gallery__dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', english ? 'Choose an image' : 'Choisir un visuel');
      controls.append(dots);
      wrapper.append(controls);
      let active = 0, frame = 0, destination = null;
      const update = index => {
        active = index;
        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        nav?.querySelectorAll('button').forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
        previous.disabled = index === 0;
        next.disabled = index === media.length - 1;
        // Hidden slides must not leave video/model controls in the keyboard order.
        media.forEach((item, i) => {
          item.inert = mobile.matches && i !== index;
          if (mobile.matches && i !== index) item.querySelectorAll('video').forEach(video => video.pause());
        });
      };
      const go = (index, behavior = reduced.matches ? 'instant' : 'smooth') => {
        index = Math.max(0, Math.min(index, media.length - 1));
        if (mobile.matches) {
          destination = index;
          const left = media[index].getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft;
          gallery.scrollTo({left, behavior});
        } else media[index].scrollIntoView({behavior, block:'start'});
        update(index);
      };
      media.forEach((item,index)=>{
        item.classList.add('fig');const button=document.createElement('button');button.type='button';button.className='thumb';button.setAttribute('aria-label',`${document.documentElement.lang==='en'?'Media':'Visuel'} ${index+1}`);
        const image=item.querySelector('img');if(image){const thumb=image.cloneNode();thumb.alt='';thumb.removeAttribute('id');thumb.loading='lazy';button.append(thumb);}else button.textContent=String(index+1).padStart(2,'0');
        button.addEventListener('click',()=>go(index));nav?.append(button);
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-gallery__dot';
        dot.setAttribute('aria-label', english ? `Image ${index + 1} of ${media.length}` : `Visuel ${index + 1} sur ${media.length}`);
        dot.setAttribute('aria-controls', item.id);
        dot.addEventListener('click', () => go(index));
        dots.append(dot);
      });
      previous.addEventListener('click', () => go((destination ?? active) - 1));
      next.addEventListener('click', () => go((destination ?? active) + 1));
      gallery.addEventListener('pointerdown', () => { destination = null; }, {passive:true});
      gallery.addEventListener('wheel', () => { destination = null; }, {passive:true});
      gallery.addEventListener('keydown', event => {
        if (!mobile.matches || event.target !== gallery) return;
        const keys = {ArrowLeft:active - 1, ArrowRight:active + 1, Home:0, End:media.length - 1};
        if (!(event.key in keys)) return;
        event.preventDefault();go(keys[event.key]);
      });
      // Native horizontal scrolling handles touch swipes; track the visible slide
      // rather than maintaining a separate, potentially stale click-only index.
      gallery.addEventListener('scroll', () => {
        if (!mobile.matches || frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const left = gallery.getBoundingClientRect().left;
          const distances = media.map(item => Math.abs(item.getBoundingClientRect().left - left));
          update(distances.indexOf(Math.min(...distances)));
          if (destination !== null && distances[destination] < 1) destination = null;
        });
      }, {passive:true});
      const resize = new ResizeObserver(() => {
        if (mobile.matches) go(destination ?? active, 'instant');
        else { destination = null;update(active); }
      });
      resize.observe(gallery);
      galleryCleanups.set(section, () => { resize.disconnect();cancelAnimationFrame(frame); });
      update(0);
    });
  }
  initProducts();
  document.addEventListener('shopify:section:load',event=>initProducts(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-product-section]').forEach(section => galleryCleanups.get(section)?.());
  });
  function initCollection(scope = document) {
    const root = scope.querySelector('[data-collection-products]') || (scope.matches?.('[data-collection-products]') ? scope : null);
    if (!root || root.dataset.loadReady === 'true') return;
    root.dataset.loadReady = 'true';
    const grid = root.querySelector('[data-product-grid]');
    const more = root.querySelector('[data-load-more]');
    const count = root.querySelector('[data-load-count]');
    const meter = root.querySelector('[data-load-meter]');
    const button = root.querySelector('[data-load-button]');
    if (!grid || !more || !count || !meter || !button) return;
    const params = new URLSearchParams(location.search);
    const selectedCategory = params.get('gm_category') || root.dataset.category || '';
    const selectedSub = params.get('gm_sub') || root.dataset.sub || '';
    root.dataset.category = selectedCategory;
    root.dataset.sub = selectedSub;
    // Shopify's filter GET form must carry the client-side category context.
    // Keep it on clear as well, so removing filters never leaves the category.
    const section = root.closest('.shopify-section') || scope;
    const filterForm = section.querySelector('[data-collection-filter-form]');
    const clearFilters = section.querySelector('[data-clear-collection-filters]');
    const categoryParams = { gm_category: selectedCategory, gm_sub: selectedSub };
    if (filterForm) {
      Object.entries(categoryParams).forEach(([name, value]) => {
        let input = filterForm.querySelector(`input[name="${name}"]`);
        if (!value) { input?.remove(); return; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          filterForm.append(input);
        }
        input.value = value;
      });
    }
    if (clearFilters) {
      const clearUrl = new URL(clearFilters.href, location.origin);
      Object.entries(categoryParams).forEach(([name, value]) => {
        if (value) clearUrl.searchParams.set(name, value);
        else clearUrl.searchParams.delete(name);
      });
      clearFilters.href = clearUrl.pathname + clearUrl.search;
    }
    const allCards = [...grid.querySelectorAll('.gm-tax-product')];
    allCards.forEach(card => card.classList.toggle('is-filtered', !!selectedCategory && card.dataset.gmCategory !== selectedCategory || !!selectedSub && card.dataset.gmSub !== selectedSub));
    const categoryLabels = document.documentElement.lang === 'en'
      ? {face:'Face', makeup:'Makeup', body:'Body', hair:'Hair'}
      : {face:'Visage', makeup:'Maquillage', body:'Corps', hair:'Cheveux'};
    const subLabels = document.documentElement.lang === 'en'
      ? {face:['Cleanser','Toner','Serum & ampoule','Cream','Sun care','Mask & pad'], makeup:['Complexion','Lips & cheeks','Eyes'], body:['Cleansers','Moisturizers'], hair:['Shampoo','Treatment','Styling','Oil']}
      : {face:['Nettoyant','Lotion tonique','Sérum & ampoule','Crème','Solaire','Masque & disque'], makeup:['Teint','Lèvres & joues','Yeux'], body:['Nettoyant','Hydratant'], hair:['Shampooing','Soin','Coiffage','Huile']};
    const subHandles = {face:['face-cleansers','face-toners','face-serums','face-creams','face-sun-care','face-masks-pads'], makeup:['makeup-complexion','makeup-lips-cheeks','makeup-eyes'], body:['body-cleansers','body-moisturizers'], hair:['hair-shampoo','hair-treatment','hair-styling','hair-oils']};
    if(selectedCategory){
      const title = document.querySelector('.plp-title');
      if(title && categoryLabels[selectedCategory]) title.textContent = categoryLabels[selectedCategory];
      const nav = root.querySelector('.plp__side nav');
      if(nav && subHandles[selectedCategory]){
        const base = location.pathname;
        const current = selectedSub;
        nav.innerHTML = `<ul class="side__list"><li><a href="${base}?gm_category=${selectedCategory}"${current?'':' aria-current="page"'}><span class="side__label">${document.documentElement.lang === 'en' ? 'View all' : 'Tout voir'}</span></a></li>${subHandles[selectedCategory].map((handle,index)=>`<li><a href="${base}?gm_category=${selectedCategory}&amp;gm_sub=${handle}"${current===handle?' aria-current="page"':''}><span class="side__label">${subLabels[selectedCategory][index]}</span></a></li>`).join('')}</ul>`;
      }
    }
    const cards = allCards.filter(card => !card.classList.contains('is-filtered'));
    const step = 12;
    let shown = 0;
    const update = () => {
      cards.forEach((card, index) => card.classList.toggle('is-more', index >= shown));
      const total = cards.length;
      count.textContent = `${shown} ${document.documentElement.lang === 'en' ? 'products displayed out of' : 'produits affichés sur'} ${total}`;
      meter.style.width = total ? `${Math.round(shown / total * 100)}%` : '0%';
      more.hidden = shown >= total;
      button.disabled = shown >= total;
    };
    shown = Math.min(step, cards.length);
    update();
    button.addEventListener('click', () => { shown = Math.min(shown + step, cards.length); update(); });
  }
  initCollection();
  document.addEventListener('shopify:section:load', event => initCollection(event.target));
  function updateBuybar(){
    const bar=document.querySelector('[data-buybar]'),cta=document.querySelector('.product-form .btn--buy'),footer=document.querySelector('.foot');
    if(!bar||!cta)return;
    const passed=cta.getBoundingClientRect().bottom<0,end=!!footer&&footer.getBoundingClientRect().top<innerHeight;
    bar.classList.toggle('is-on',passed);bar.classList.toggle('is-end',end);bar.setAttribute('aria-hidden',String(!passed||end));bar.inert=!passed||end;
  }
  let buybarFrame=0;
  addEventListener('scroll',()=>{if(!buybarFrame)buybarFrame=requestAnimationFrame(()=>{buybarFrame=0;updateBuybar();});},{passive:true});
  addEventListener('resize',updateBuybar);
  updateBuybar();

  function errorMessage(form, message) {
    const error = form.querySelector('[data-form-error]');
    if (error) { error.textContent = message; error.hidden = false; }
  }
  function openCart() {return window.GlowmeDrawer?.open('CartDrawer')||false;}
  function updateCart(html) {
    const next=new DOMParser().parseFromString(html,'text/html').querySelector('#CartDrawer'),previous=document.getElementById('CartDrawer');
    if(!next||!previous)return false;
    window.GlowmeDrawer?.close(true);previous.replaceWith(next);return true;
  }
  function updateCounts(cart){document.querySelectorAll('[data-cart-count]').forEach(count=>{count.textContent=cart.item_count;count.closest('[data-count]')?.setAttribute('data-count',cart.item_count);});}
  let cartPending = false;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-cart-add]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    if (cartPending || form.closest('[data-product-section][aria-busy=true]')) return;
    cartPending = true;
    const button = form.querySelector('[type=submit]');
    const wasDisabled = button?.disabled;
    const buttonLabel = button?.textContent;
    const error = form.querySelector('[data-form-error]');
    if (error) error.hidden = true;
    form.setAttribute('aria-busy', 'true');
    if (button) {
      button.disabled = true;
      if (button.dataset.loadingLabel) button.textContent = button.dataset.loadingLabel;
    }
    let added = false;
    try {
      const data = new FormData(form);
      data.set('sections', 'gm-cart-drawer');
      data.set('sections_url', location.pathname);
      const response = await fetch(`${document.body.dataset.cartAddUrl}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : document.body.dataset.cartError);
      added = true;
      document.querySelector('[data-cart-status]').textContent = document.body.dataset.added;
      const cartResponse = await fetch(`${document.body.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) { location.assign(document.body.dataset.cartUrl); return; }
      const cart = await cartResponse.json();
      updateCounts(cart);
      if (result.sections?.['gm-cart-drawer'] && updateCart(result.sections['gm-cart-drawer']) && openCart()) return;
      location.assign(document.body.dataset.cartUrl);
    } catch (error) {
      if (added) { location.assign(document.body.dataset.cartUrl); return; }
      errorMessage(form, error instanceof TypeError ? document.body.dataset.cartError : error.message || document.body.dataset.cartError);
    } finally {
      form.removeAttribute('aria-busy');
      if (button) {
        button.disabled = wasDisabled;
        if (button.dataset.loadingLabel) button.textContent = buttonLabel;
      }
      cartPending = false;
    }
  });
  // Main cart quantity controls mirror the prototype's three-cell control.
  // The native cart form remains the source of truth; submit after a short
  // pause so repeated clicks coalesce into one update request.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-page-qty] [data-qty-step]');
    if (!button) return;
    const group = button.closest('[data-cart-page-qty]');
    const input = group?.querySelector('input.quantity');
    if (!input) return;
    event.preventDefault();
    const step = Number(input.step) || 1;
    const delta = Number(button.dataset.qtyStep || 0) * step;
    const min = Number(input.min || 0);
    const max = input.max ? Number(input.max) : Infinity;
    const next = Math.min(max, Math.max(min, (Number(input.value) || 0) + delta));
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const form = group.closest('form');
    if (!form) return;
    clearTimeout(form._gmQtyTimer);
    form._gmQtyTimer = setTimeout(() => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }, 220);
  });
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-cart-quantity]');if(!button||cartPending)return;
    const line=button.closest('[data-cart-line]'),drawer=document.getElementById('CartDrawer');cartPending=true;drawer.setAttribute('aria-busy','true');
    try{
      const response=await fetch(`${document.body.dataset.cartUrl}/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.dataset.cartLine,quantity:Number(button.dataset.cartQuantity),sections:['gm-cart-drawer'],sections_url:location.pathname})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||document.body.dataset.cartError);
      updateCounts(result);if(result.sections?.['gm-cart-drawer']){updateCart(result.sections['gm-cart-drawer']);openCart();}else location.assign(document.body.dataset.cartUrl);
    }catch(error){const output=drawer.querySelector('[data-drawer-error]');output.textContent=error.message||document.body.dataset.cartError;output.hidden=false;}
    finally{cartPending=false;document.getElementById('CartDrawer')?.removeAttribute('aria-busy');}
  });

  // Resolve option combinations on Shopify, including products with >250 variants.
  const variantRequests = new WeakMap();
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-option-value]');
    if (!input) return;
    const section = input.closest('[data-product-section]');
    const optionScope = section.querySelector('[data-variant-options]');
    const values = [...optionScope.querySelectorAll('[data-option-value]:checked')].map(option => option.value);
    const url = new URL(location.href);
    url.searchParams.delete('variant');
    url.searchParams.set('option_values', values.join(','));
    const request = new URL(url);
    const legacyImages = document.querySelector('[data-legacy-product-images]');
    const sectionIds = [section.dataset.productSection];
    if (legacyImages) sectionIds.push(legacyImages.dataset.legacyProductImages);
    request.searchParams.set('sections', sectionIds.join(','));
    variantRequests.get(section)?.abort();
    const controller = new AbortController();
    variantRequests.set(section, controller);
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = true; });
    try {
      const response = await fetch(request, { signal: controller.signal });
      if (!response.ok) throw new Error('Unable to load variant');
      const rendered = await response.json();
      if (sectionIds.some(id => !rendered[id])) throw new Error('Missing product section');
      const html = new DOMParser().parseFromString(sectionIds.map(id => rendered[id]).join(''), 'text/html');
      if (controller.signal.aborted || variantRequests.get(section) !== controller) return;
      const next = html.querySelector('[data-product-section]');
      if (!next) throw new Error('Missing product section');
      const nextLegacy = html.querySelector('[data-legacy-product-images]');
      if (legacyImages && !nextLegacy) throw new Error('Missing product detail images');
      galleryCleanups.get(section)?.();
      section.replaceWith(next);
      if (legacyImages) legacyImages.replaceWith(nextLegacy);
      initProducts(next);
      updateBuybar();
      history.replaceState({}, '', url);
      const focus = [...next.querySelectorAll('[data-option-value]')].find(option => option.value === input.value);
      focus?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url);
    } finally {
      if (variantRequests.get(section) === controller) section.removeAttribute('aria-busy');
    }
  });
})();
